var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"secondary top-0 fw-600",attrs:{"type":"button","id":"deleteApptBtn","name":"deleteApptBtn"},on:{"click":_vm.openDeleteModal}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }